import React, { useEffect, useState } from 'react';
import { fetcher } from '../../../../../../helpers/fetcher';
import { configApiLinks } from '../../../../../../configApiLinks';
import {
  setCheckData,
} from '../../../../../../actions/checks';
import { useDispatch } from 'react-redux';

export const useReceiptsPostponedList = () => {
  const [modalShow, setModalShow] = useState(false);
  const [receiptsData, setReceiptsData] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const [filterDate, setFilterDate] = useState(new Date());
  const dispatch = useDispatch();

  useEffect(() => {
    if (modalShow === true) {
      getPostponedReceipts(filterDate);
    }
  }, [modalShow]);

  const getPostponedReceipts = (inDate) => {
    if (inDate !== filterDate) {
      setFilterDate(inDate);
    }
    setShowLoader(true);
    fetcher(configApiLinks.getPostponedReceipts, 'POST', {
      date: Date.parse(inDate)
    }).then((data) => {
      setShowLoader(false);
      setReceiptsData(data);
    }).catch((data) => {
      setShowLoader(false);
      console.error('Error fetching postponed receipts:', data);
    });
  };

  const selectPostponedReceipt = (receiptWrapId) => {
    setShowLoader(true);
    fetcher(configApiLinks.selectPostponedReceipt, 'POST', {
      receiptWrapId: receiptWrapId
    }).then((data) => {
      setShowLoader(false);
      dispatch(setCheckData(data));
      setModalShow(false);
    }).catch((data) => {
      setShowLoader(false);
      console.error('Error selecting postponed receipt:', data);
    });
  };

  // here we put
  const delay = (callback, ms) => {
    let timer = 0;
    // return function because keyup require function
    return function () {
      let context = this;
      let args = arguments;
      // if we put something again clear timer (do not wait for result function below) amd start timer again
      clearTimeout(timer);
      timer = setTimeout(function () {
        // runs function on key up ajax send format url etc...
        callback.apply(context, args);
      }, ms);
    };
  };
  return {
    delay,
    getPostponedReceipts,
    selectPostponedReceipt,
    modalShow,
    receiptsData,
    showLoader,
    filterDate,
    setModalShow,
  };
};
